import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
export function validateDeepLinkJson(deepLinkJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // DeepLinkJson => RichAssetDeepLink => RichAsset => Node
    const parentNode = deepLinkJson.$container?.$container
        ?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: deepLinkJson,
        allProperties: deepLinkJson.properties,
        requiredProperties: [
            ast.LabelProperty,
            ast.IosUrlProperty,
            ast.AndroidUrlProperty,
            ast.IosStoreProperty,
            ast.AndroidStoreProperty,
        ],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=deep-link.js.map